import { useUserStore } from '@local/shared';
import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PageAccessDenied, PageUnauthorized } from '../../page-401';
import { PageCase } from '../../page-case';
import { PageChatbot } from '../../page-chatbot';
import { PageSearch } from '../../page-search';

export const PageRouting: FC = observer(() => {
    const userStore = useUserStore();
    const hasAccess = userStore.user?.hasAccess;

    return (
        <Switch>
            <Route path="/error/401/access-denied" exact>
                <PageAccessDenied />
            </Route>
            <Route path="/error/401">
                <PageUnauthorized />
            </Route>
            <Route path="/chatbot">
                <PageChatbot />
            </Route>
            {hasAccess ? (
                <Fragment>
                    <Route path="/case/:caseId">
                        <PageCase />
                    </Route>
                    <Route path="/" exact>
                        <PageSearch />
                    </Route>
                </Fragment>
            ) : (
                <Redirect to="/chatbot" />
            )}
        </Switch>
    );
});
